import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Link } from 'react-router-dom';
import { Input } from 'antd';

import Nav from '../../utils/nav';
import Footer from '../../utils/footer';

import locationMap from '../../assets/images/content/locationmap.jpg';

const Contact = () => {
    const { handleSubmit, control } = useForm({});
    const { TextArea } = Input;
    return (
        <div>
            <Nav />
            <div className="contact_bg">
                <h1>Contact Us</h1>
            </div>
            <div className="contact contain">
                <div className="grid_2">
                    <div>
                        <h4>Reach out to Us</h4>
                        <div className="mt_3">
                            <form>
                                <div className="form_flex">
                                    <div className="form_group">
                                        <label>First name</label>
                                        <Controller name="firstName" control={control}
                                            render={({ field }) => (
                                                <Input
                                                    style={{ height: '3rem' }}
                                                    {...field} name="firstName" />
                                            )} />
                                    </div>
                                    <div className="form_group">
                                        <label>Last name</label>
                                        <Controller name="firstName" control={control}
                                            render={({ field }) => (
                                                <Input
                                                    style={{ height: '3rem' }}
                                                    {...field} name="firstName" />
                                            )} />
                                    </div>
                                </div>
                                <div className="form_flex">
                                    <div className="form_group">
                                        <label>Email address</label>
                                        <Controller name="firstName" control={control}
                                            render={({ field }) => (
                                                <Input
                                                    style={{ height: '3rem' }}
                                                    {...field} name="firstName" />
                                            )} />
                                    </div>
                                    <div className="form_group">
                                        <label>Phone number <small>(optional)</small></label>
                                        <Controller name="firstName" control={control}
                                            render={({ field }) => (
                                                <Input
                                                    style={{ height: '3rem' }}
                                                    {...field} name="firstName" />
                                            )} />
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>Your message</label>
                                    <TextArea name="firstName" rows="5" />
                                </div>
                                <button className="btn-accent">Get in touch with us</button>
                            </form>
                        </div>
                    </div>
                    <div>
                        <h3>Or you can message us directly</h3>
                        <div className="sticky_compartment">
                            <p>For general inquiries, please call 08169511139
                            </p>
                            <p>For issues with our product delivery, please call 08023414932</p>
                            <p className="mt_3">To understand what we do and a better insight into how we work, kindly
                                visit our Instagram page @vo3designs</p>
                        </div>
                        <img src={locationMap} style={{ width: 'unset', height: 'unset' }} alt="locationMap" />
                        <div className="sticky_social">
                            <div>
                                <ion-icon name="logo-facebook"></ion-icon>
                                <ion-icon name="logo-twitter"></ion-icon>
                                <ion-icon name="logo-instagram"></ion-icon>
                                <ion-icon name="logo-youtube"></ion-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer margin={true} />
        </div >
    )
}

export default Contact;